import * as React from "react";
import { RawContentEdit } from "./Editor.styles";
import { IRawContent } from "./types";

interface IRawEditorComponent {
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  rawContent: IRawContent;
}

export const RawContentEditor: React.FunctionComponent<IRawEditorComponent> = ({
  onChange,
  rawContent: { editing, value },
}) => {
  if (!editing) {
    return null;
  }
  const rows = value.split("\n").length;
  return <RawContentEdit {...{ value, rows, onChange }} />;
};
